import { render, staticRenderFns } from "./TestingContent.vue?vue&type=template&id=3abd2650&lang=pug&"
import script from "./TestingContent.vue?vue&type=script&lang=js&"
export * from "./TestingContent.vue?vue&type=script&lang=js&"
import style0 from "./TestingContent.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports